import { GridColDef } from "@mui/x-data-grid-pro";
import { GKClientDataGrid, StatusField, Typography } from "components";
import { useFetchQuery } from "hooks/useQueries";
import { useParams } from "react-router-dom";
import { extraColumnsField, matchDate } from "utils/helpers";

const ViewTelegramTab = () => {
  const { id } = useParams<{ id: string }>();

  const { data } = useFetchQuery({
    key: ["TELEGRAM_CHANNELS", id],
    route: `/telegram-channels/?basket=${id}`,
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Channel Name", "channelName", 120, 1),
    },
    {
      ...extraColumnsField("Channel Id", "channelId", 120, 1),
    },
    {
      ...extraColumnsField("Status", "isActive", 120, 1),
      renderCell: (params) => (
        <StatusField
          statusString={params.row.isActive ? "approved" : "pending"}
        />
      ),
    },
    {
      ...extraColumnsField("Created", "createdAt", 120, 1),
      renderCell: (value) => (
        <Typography>{matchDate(value.row.createdAt) || "N/A"}</Typography>
      ),
    },
  ];

  return (
    <>
      <GKClientDataGrid
        // maxHeight={"240px"}
        columns={columns}
        rows={data?.data?.data || []}
        name="telegramTab"
      />
    </>
  );
};

export default ViewTelegramTab;
